import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TRANSLATIONS_STATIC_PATH } from "shared/routes/paths";
import { useAuthUserStore } from "../../stores/authUserStore";
import { useUserRoleStore } from "../../stores/userRoleStore";
import { isLocationAllowed } from "./utils";

const useProtectedRoute = (): void => {
  const { roles, loading } = useUserRoleStore();
  const { firebaseUser } = useAuthUserStore();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      return;
    }

    if (
      firebaseUser &&
      (!roles.length || !isLocationAllowed(location.pathname, roles))
    ) {
      navigate(TRANSLATIONS_STATIC_PATH, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, roles, loading, firebaseUser]);
};

export default useProtectedRoute;
